<template>
   <g>
      <path
         d="M5.44737 9.55263H8.18421M5.44737 6.13158H10.9211M2.71053 3.73684H1M2.71053 7.8421H1M2.71053 11.9474H1M2.02632 6.47368C2.02632 3.89353 2.02632 2.60311 2.82821 1.80189C3.63011 1.00068 4.91984 1 7.5 1H8.52632C11.1065 1 12.3969 1 13.1981 1.80189C13.9993 2.60379 14 3.89353 14 6.47368V9.21053C14 11.7907 14 13.0811 13.1981 13.8823C12.3962 14.6835 11.1065 14.6842 8.52632 14.6842H7.5C4.91984 14.6842 3.62942 14.6842 2.82821 13.8823C2.027 13.0804 2.02632 11.7907 2.02632 9.21053V6.47368Z"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-supplies',
         viewBox: '0 0 15 16',
         width: 15,
         height: 16,
         fill: 'none',
      };
   },
};
</script>
